/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { fetcher } from "./sender";
import { CFG_BASE_URL } from '../constants/config'

export const getInventory = (farmId: any, foodSupplierId: string) => {
    return fetcher.get(`${CFG_BASE_URL}/foodInventory`, { farmId, foodSupplierId });
}